var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIco155Symbol = function SvgIco155Symbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "ico-155-symbol_svg__ico-155-symbol",
    style: {
      overflow: "visible"
    },
    viewBox: "0 0 92 57"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes typewriter-reveal{0%{opacity:0;transform:rotateY(-90deg) scale(.5)}20%{opacity:1;transform:rotateY(0deg) scale(1.1)}30%{transform:rotateY(0deg) scale(.95)}40%{transform:rotateY(0deg) scale(1.05)}50%{transform:rotateY(0deg) scale(1)}80%{opacity:1;transform:rotateY(0deg) scale(1)}90%{opacity:.7;transform:rotateY(45deg) scale(.8)}to{opacity:0;transform:rotateY(90deg) scale(.5)}}")), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "typewriter-reveal 3s cubic-bezier(.25,.46,.45,.94) infinite",
      transformOrigin: "13.8134px 28.5px",
      animationDelay: "0ms",
      willChange: "transform,opacity",
      backfaceVisibility: "hidden",
      perspective: 1000
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.003 57c-2.451 0-3.677 0-4.613-.475a4.37 4.37 0 0 1-1.913-1.903C0 53.69 0 52.47 0 50.03V6.969C0 4.53 0 3.31.477 2.38A4.37 4.37 0 0 1 2.39.474C3.326 0 4.552 0 7.003 0h13.62c2.452 0 3.678 0 4.614.475a4.37 4.37 0 0 1 1.913 1.903c.477.932.477 2.152.477 4.591v43.062c0 2.44 0 3.659-.477 4.59a4.37 4.37 0 0 1-1.913 1.904c-.936.475-2.162.475-4.613.475z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.17 15.176h3.373v27.79h-4.197V23.138H6.953v-3.083l.628-.04c2-.116 3.49-.546 4.51-1.248 1.02-.703 1.687-1.913 2.079-3.591"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.749 14.648h4.325v28.846h-5.258V23.666H6.423V19.56l1.127-.07c1.95-.114 3.331-.53 4.24-1.156.866-.598 1.486-1.662 1.863-3.277zm-.403 8.49v19.828h4.197v-27.79H14.17c-.392 1.678-1.059 2.888-2.079 3.59-1.02.704-2.51 1.133-4.51 1.25l-.628.039v3.083z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "typewriter-reveal 3s cubic-bezier(.25,.46,.45,.94) infinite",
      transformOrigin: "46.033px 28.5px",
      animationDelay: ".3s",
      willChange: "transform,opacity",
      backfaceVisibility: "hidden",
      perspective: 1000
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.223 57c-2.452 0-3.677 0-4.614-.475a4.37 4.37 0 0 1-1.912-1.903c-.477-.932-.477-2.152-.477-4.591V6.969c0-2.44 0-3.659.477-4.59A4.37 4.37 0 0 1 34.609.474C35.546 0 36.771 0 39.223 0h13.62c2.452 0 3.677 0 4.613.475a4.37 4.37 0 0 1 1.913 1.903c.477.932.477 2.152.477 4.591v43.062c0 2.44 0 3.659-.477 4.59a4.37 4.37 0 0 1-1.912 1.904C56.52 57 55.295 57 52.843 57z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.382 43.448h-.449c-4.93 0-7.497-2.068-7.7-8.19h5.011c.163 3.365 1.1 3.973 2.852 3.973 2.078 0 2.812-.932 2.812-4.5v-2.352c0-3.568-.815-4.46-2.893-4.46-1.426 0-2.486.446-3.015 3h-4.523l.937-16.26h14.017v4.339h-9.494l-.448 7.015h.163c.774-1.42 1.792-2.23 4.278-2.23 3.87 0 5.949 1.986 5.949 7.866v2.514c0 7.055-2.323 9.285-7.497 9.285"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "typewriter-reveal 3s cubic-bezier(.25,.46,.45,.94) infinite",
      transformOrigin: "78.1848px 28.5px",
      animationDelay: ".6s",
      willChange: "transform,opacity",
      backfaceVisibility: "hidden",
      perspective: 1000
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.376 57c-2.451 0-3.677 0-4.613-.475a4.37 4.37 0 0 1-1.913-1.903c-.477-.932-.477-2.152-.477-4.591V6.969c0-2.44 0-3.659.477-4.59A4.37 4.37 0 0 1 66.763.474C67.699 0 68.925 0 71.376 0h13.62c2.452 0 3.678 0 4.614.475a4.37 4.37 0 0 1 1.913 1.903C92 3.31 92 4.53 92 6.97v43.062c0 2.44 0 3.659-.477 4.59a4.37 4.37 0 0 1-1.913 1.904c-.936.475-2.162.475-4.613.475z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M78.535 43.448h-.448c-4.93 0-7.497-2.068-7.701-8.19h5.012c.163 3.365 1.1 3.973 2.852 3.973 2.078 0 2.811-.932 2.811-4.5v-2.352c0-3.568-.815-4.46-2.893-4.46-1.426 0-2.485.446-3.015 3H70.63l.938-16.26h14.016v4.339H76.09l-.448 7.015h.163c.774-1.42 1.793-2.23 4.278-2.23 3.871 0 5.95 1.986 5.95 7.866v2.514c0 7.055-2.323 9.285-7.498 9.285"
  }))));
};
export default SvgIco155Symbol;